var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "TcWelcome" }, [
    _c(
      "div",
      { staticClass: "container mx-auto" },
      [
        _c("div", { staticClass: "flex flex-col mx-auto max-w-5xl pt-3" }, [
          _c("p", { staticClass: "help  text-center mb-3" }, [
            _vm._v(
              "En este espacio podrás solicitar Cita Previa e Inscribirte en eventos y actividades "
            )
          ]),
          _vm._v(" "),
          _c(
            "p",
            { staticClass: "instructions text-center max-w-2xl mx-auto" },
            [
              _vm._v(
                "Introduce tu DNIe en el lector de tarjetas y pulsa en comenzar"
              )
            ]
          ),
          _vm._v(" "),
          _c("img", {
            staticClass: "mx-auto my-5",
            staticStyle: { width: "327px" },
            attrs: { src: "/assets/img/img1.png" }
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "buttons flex flex-col gap-4 mx-auto max-w-xl w-full text-center"
            },
            [
              _c(
                "button",
                {
                  on: {
                    click: function($event) {
                      return _vm.click("login-dni")
                    }
                  }
                },
                [
                  _c("TcIcon", {
                    staticClass: "h-10 w-10 mr-3",
                    attrs: { icon: "card" }
                  }),
                  _vm._v(" Entrar con DNI electrónico")
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn-secondary",
                  on: {
                    click: function($event) {
                      return _vm.click("login")
                    }
                  }
                },
                [
                  _c("TcIcon", {
                    staticClass: "h-10 w-10 mr-3",
                    attrs: { icon: "key" }
                  }),
                  _vm._v(" Entrar con contraseña")
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn-secondary",
                  on: {
                    click: function($event) {
                      return _vm.click("login-public")
                    }
                  }
                },
                [
                  _c("TcIcon", {
                    staticClass: "h-10 w-10 mr-3",
                    attrs: { icon: "group" }
                  }),
                  _vm._v(" Acceso público")
                ],
                1
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c("NewsSlider")
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }